// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14ELH","expireSoon":"styles_expireSoon__Zf7Xi"};